var map = {
	"./冰雹.png": 43370,
	"./冰雹_红色预警.png": 43578,
	"./台风.png": 94309,
	"./台风_橙色预警.png": 17177,
	"./台风_红色预警.png": 17964,
	"./台风_蓝色预警.png": 94502,
	"./大雾.png": 51844,
	"./大雾_橙色预警.png": 66549,
	"./大雾_红色预警.png": 50266,
	"./大风.png": 34390,
	"./大风_橙色预警.png": 70277,
	"./大风_红色预警.png": 98620,
	"./大风_黄色预警.png": 84363,
	"./寒潮.png": 70502,
	"./寒潮_橙色预警.png": 66098,
	"./寒潮_红色预警.png": 22550,
	"./寒潮_黄色预警.png": 52616,
	"./干旱.png": 7877,
	"./干旱_红色预警.png": 73861,
	"./暴雨.png": 195,
	"./暴雨_橙色预警.png": 39000,
	"./暴雨_红色预警.png": 15214,
	"./暴雨_黄色预警.png": 54406,
	"./暴雪.png": 43459,
	"./暴雪_橙色预警.png": 18013,
	"./暴雪_红色预警.png": 92990,
	"./暴雪_蓝色预警.png": 88810,
	"./森林火险.png": 88140,
	"./沙尘暴.png": 93383,
	"./沙尘暴_红色预警.png": 61895,
	"./沙尘暴_黄色预警.png": 86076,
	"./结冰.png": 83731,
	"./结冰_橙色预警.png": 76522,
	"./结冰_红色预警.png": 21451,
	"./重污染.png": 75774,
	"./重污染_橙色预警.png": 32163,
	"./重污染_红色预警.png": 99353,
	"./重污染_黄色预警.png": 97209,
	"./雷电.png": 75222,
	"./雷电_红色预警.png": 13744,
	"./霜冻.png": 36427,
	"./霜冻_橙色预警.png": 41387,
	"./霜冻_蓝色预警.png": 32665,
	"./霾.png": 39693,
	"./霾_黄色预警.png": 48804,
	"./高温.png": 79720,
	"./高温_橙色预警.png": 25878,
	"./高温_红色预警.png": 98013
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56680;